
import { useState, useEffect, createContext, Component } from 'react';
import axios from 'axios';

import CurrencyFormat from 'react-currency-format';

import {api_path} from '../../../../server.js'; 
//ESTOU TENTANDO PASSAR UM VAOR PARA O QUADRO PAI
export default function CampoAuxiliares({CulturaCombo}){
//, faseExportada
  const [fase_gatilho, setFase_gatilho] = useState('');
  const [campos, setCampos] = useState([]);
  const [nrcampos, setNrCampos] = useState([]);
  const [nrcampos2, setNrCampos2] = useState([]);
  const [campos2, setCampos2] = useState([]);
  const [fase, setFase] = useState([]);

  const [faseExportada, setFaseExportada] = useState('');
  
  useEffect(()=>{
    let unmounted = false;
    if(!unmounted){
      //M.AutoInit();
      setCamposFaseGatilhoVazio();
      getCamposFaseGatilho('fase_gatilho', '');
      getCampos();
      
    }
    return () =>{
      unmounted=true;
    };
  }, [CulturaCombo])

  async function getCampos(){
    
    const body = {
      cultura: CulturaCombo,
      acao: 'getCampoFaseFenologica'
    }
    //console.log('ss');
    axios.post(api_path()+'sistema/analisesolo/culturas.camposadicionais.php', body, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then((response) => {
      let listaCulturas = response.data;
      var nrfields = listaCulturas.length;
      setCampos(listaCulturas);
      setNrCampos(nrfields);
      
        for (var i = 0; i < nrfields; i++) {
          const setCamposMontados = () => {
          let tipocampo = listaCulturas[i].type;
          if(tipocampo==="select")
              {
                return (
                  <div>
                    <select key={i}>
                    </select>
                  </div>
                );
              }
          };
        }

        })
        .catch(function (response) {
            console.log(response)
        });
        return;

  }

function setCamposFaseGatilhoVazio(){
  //document.getElementById("fase_gatilho").selectedIndex = "-1";
  setCampos('');
}

function getCamposFaseGatilho(field, fieldValue){
  if(field==="fase_gatilho"){

    setFaseExportada(fieldValue);

    const body = {
      cultura: CulturaCombo,
      fase: fieldValue,
      acao: 'getCamposAuxiliares'
    }

    axios.post(api_path()+'sistema/analisesolo/culturas.camposadicionais.php', body, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then((response) => {
      let listaCulturas2 = response.data;
      var nrfields2 = listaCulturas2.length;
      setCampos2(listaCulturas2);
      setNrCampos2(nrfields2);

        for (var i = 0; i < nrfields2; i++) {
          const setCamposMontados = () => {
          let tipocampo = listaCulturas2[i].type;
          if(tipocampo==="select")
              {
                return (
                  <div>
                    <select key={i}>
                    </select>
                  </div>
                );
              }
          };
        }

      })
      .catch(function (response) {
            console.log(response)
      });

  }
}


   //handleComboBox
  function handleComboBox(e){
    let field = e.target.name;
    let fieldValue = e.target.value;
    getCamposFaseGatilho(field, fieldValue)
  }




  return(

    
    <div class="grid-x grid-padding-x">

      { campos && 
            campos.map((item, index) => {
              
              if(item.type==="select"){
              return(
                <div className="small-12 medium-4 large-3 cell">
                <label>{item.label}
                <select name={item.field} key={item.field} onChange={(e)=>handleComboBox(e)} required>
                  <option value="">Selecione...</option>
                    {item.values.map((opt) => <option value={opt.value}>{opt.legend}</option>)}
                  </select>
                  </label>
              </div>
                )
              }
              if(item.type==="text"){
              return(
                <div className="small-12 medium-4 large-3 cell">
                  <label>{item.label}
                    <CurrencyFormat name={item.field} key={item.field} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                  </label>
              </div>
                )
              }
              })
      }

      { campos2 && 
            campos2.map((item, index) => {
              if(item.type==="select"){
              return(
                <div className="small-12 medium-4 large-3 cell">
                  <label htmlFor={item.field}>{item.label}
                    <select name={item.field} id={item.field} onChange={(e)=>handleComboBox(e)} required>
                      {item.values.map((opt) => <option value={opt.value}>{opt.legend}</option>)}
                    </select>
                  </label>
                  <label className="unidade">{item.unidade}</label>
              </div>
                )
              }
              if(item.type==="text"){
              return(
                <div className="small-12 medium-4 large-3 cell">
                <label htmlFor={item.field} >{item.label}
                  <CurrencyFormat name={item.field} key={item.field} thousandSeparator={false} decimalSeparator=',' decimalScale='2' required/>
                </label>
                <label className=" unidade">{item.unidade}</label>
              </div>
                )
              }
              })
      }

    </div>
  );


}

